const INTERNAL_ARTICLE = 'internal';
const EXTERNAL_ARTICLE = 'external';

module.exports = {
  INTERNAL_ARTICLE,
  EXTERNAL_ARTICLE
};
